import $ from 'jquery';

let timeSelection = $(".time-selection")
let allTimeBoxes = timeSelection.find("td")
let domainSelection = $(".domain-selection")

let domainKey = ""

domainSelection.find(".radio-inline").on('click', function (domainBox) {
    if (domainBox.target.type == 'radio') {
        domainKey = domainBox.target.id;
        domainKey = domainKey.split("domains_")[1];
        updateTimeSelection(domainKey)
    }
})

domainSelection.find(".radio-inline").each(function () {
    let input = $(this).find("input")[0]
    if ($(input).prop('checked')) {
        domainKey = input.id;
        domainKey = domainKey.split("domains_")[1];
        updateTimeSelection(domainKey)
    }
})

function updateTimeSelection (domainKey) {
    let domain = ""
    let lastTimeStep = 10000000000
    if (domainKey !== '_') {
        domain = window.mb.domains[domainKey]
        lastTimeStep = domain['lastforecasthour_utc'];
    }

    let nowFound = false
    let lastTimeStepPassed = false

    let input = ""
    let label = ""

    let timeboxNow = ""
    let revertToNow = false

    allTimeBoxes.each(function() {
        input = $(this).find("input")
        label = $(this).find("label")
        
        if ($(this).hasClass("now")) {
            timeboxNow = input;
            nowFound = true;
            return
        }
        if (nowFound) {
            if ($(this).data('ts') < lastTimeStep) {
                input.attr("disabled", false)
                label.removeClass("disabled")
            } else {
                lastTimeStepPassed = true;
            }
        }
        if (lastTimeStepPassed) {
            if (input.prop('checked')) {
                revertToNow = true
            }
            input.attr("disabled", "disabled")
            label.addClass("disabled")
        }
    });

    if (revertToNow) {
        timeboxNow.click();
    }
}